/* Free Life Labs — desktop menu v2 (LIVE on desktop >=990px since Oct 20, 2026).
   Off for the tab: ?menu=desk-off or ?menu=off.
   Must load BEFORE fll-header-premium.js (both deferred) so its hover logic picks up the new nav. */
(function () {
  var KEY = 'fllDeskV2';
  var me = document.currentScript;
  try {
    var q = new URLSearchParams(location.search).get('menu');
    // LIVE for all desktop visitors. Opt-out for the tab: ?menu=desk-off or ?menu=off; ?menu=desk-v2 clears it.
    if (q === 'desk-off' || q === 'off') sessionStorage.setItem(KEY, 'off');
    if (q === 'desk-v2' || q === 'on') sessionStorage.removeItem(KEY);
    if (sessionStorage.getItem(KEY) === 'off') return;
  } catch (e) {}
  if (!window.matchMedia('(min-width: 990px)').matches) return;
  if (window.__fllDm2) return; window.__fllDm2 = true;

  var root = document.documentElement;
  var BASE = (me && me.getAttribute('data-assets')) || '';
  var WS = !!(me && me.getAttribute('data-wholesale') === '1');
  var css = document.createElement('link'); css.rel = 'stylesheet'; css.href = me.getAttribute('data-css');
  document.head.appendChild(css);
  root.classList.add('fll-dm2');
  /* Centered menu PREVIEW: ?menu=center (persists for the tab), ?menu=center-off clears. Go-live: set FLL_MENU_CENTER = true. */
  var FLL_MENU_CENTER = true;
  try {
    var mq = new URLSearchParams(location.search).get('menu');
    if (mq === 'center') sessionStorage.setItem('fllMenuCenter', '1');
    if (mq === 'center-off') sessionStorage.removeItem('fllMenuCenter');
    if (FLL_MENU_CENTER || sessionStorage.getItem('fllMenuCenter') === '1') root.classList.add('fll-mc');
  } catch (e) { if (FLL_MENU_CENTER) root.classList.add('fll-mc'); }
  if (WS) root.classList.add('fll-dm2-ws');

  function esc(v) { return String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function noSub(s) { return WS ? s.replace(/\s*[·|-]?\s*(subscribe\s*&?\s*save|subscription|subscribe)[^·|]*/ig, '').trim() : s; }

  /* ---------- 1. Slim solid header on scroll (hysteresis so it never flickers) ---------- */
  var slim = false;
  function onScroll() {
    var y = window.scrollY || 0;
    if (!slim && y > 90) { slim = true; root.classList.add('fll-dm2-slim'); }
    else if (slim && y < 24) { slim = false; root.classList.remove('fll-dm2-slim'); }
  }
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

  /* ---------- 2. Shop All button ---------- */
  var cta = document.querySelector('.header .button.button--primary[href*="/collections/all"]');
  if (cta) { cta.textContent = 'Shop All'; cta.classList.add('fll-dm2-cta'); }

  /* ---------- 3. Five top links ---------- */
  var nav = document.querySelector('.header__inline-menu .list-menu--inline');
  function liBy(re) {
    var lis = nav ? nav.children : [];
    for (var i = 0; i < lis.length; i++) {
      var l = lis[i].querySelector('summary, a'); if (l && re.test(txt(l))) return lis[i];
    }
    return null;
  }
  if (nav) {
    var pLi = liBy(/^products$/i), aLi = liBy(/^about$/i), fLi = liBy(/^for providers$/i), lLi = liBy(/^learn$/i),
        sLi = liBy(/^science$/i), tLi = liBy(/^testimonials$/i), cLi = liBy(/^contact/i);
    if (pLi && aLi && fLi && lLi && sLi && tLi && cLi) {
      var aSum = aLi.querySelector('summary > span'); if (aSum) aSum.textContent = 'Why Free Life Labs';
      var aList = aLi.querySelector('.mega-menu__list');
      var mk = function (href, label, cls) {
        var li = document.createElement('li');
        li.innerHTML = '<a href="' + esc(href) + '" class="mega-menu__link mega-menu__link--level-2 link' + (cls ? ' ' + cls : '') + '">' + esc(label) + '</a>';
        return li;
      };
      // Life Rewards: logo image -> text link
      var rw = aList && aList.querySelector('a[href*="reward"]');
      if (rw) rw.textContent = 'Life Rewards';
      // Find a Clinic (PREVIEW: only with ?menu=clinic; go-live sets FLL_CLINIC = true)
      var FLL_CLINIC = true;
      if (FLL_CLINIC && aList && !aList.querySelector('a[href*="find-a-clinic"]')) {
        var fcLi = mk('/pages/find-a-clinic', 'Find a Clinic');
        var tAfter = aList.querySelector('a[href*="testimonial"]');
        var ref = tAfter ? tAfter.closest('li') : null;
        if (ref && ref.parentNode === aList) aList.insertBefore(fcLi, ref.nextSibling); else aList.appendChild(fcLi);
      }
      // Contact line: phone + email moved from Contact Us
      var tel = cLi.querySelector('a[href^="tel:"]'), mail = cLi.querySelector('a[href^="mailto:"]');
      // Contact moved to footer Help (PREVIEW: only with ?menu=contact; go-live sets FLL_CONTACT_FOOTER = true)
      var FLL_CONTACT_FOOTER = true;
      if (!FLL_CONTACT_FOOTER && aList && (tel || mail)) {
        var cl = document.createElement('li'); cl.className = 'fll-dm2-contact';
        cl.innerHTML = '<span class="fll-dm2-contact__label">Contact</span>' +
          (tel ? '<a class="fll-dm2-contact__a" href="' + esc(tel.getAttribute('href')) + '">Call ' + esc(tel.getAttribute('href').replace('tel:', '')) + '</a>' : '') +
          (mail ? '<a class="fll-dm2-contact__a" href="' + esc(mail.getAttribute('href')) + '">Email us</a>' : '');
        aList.appendChild(cl);
      }
      // Learn: clearer labels
      var la = lLi.querySelectorAll('.mega-menu__link');
      for (var i = 0; i < la.length; i++) {
        var h = la[i].getAttribute('href') || '';
        if (/\/blogs\//.test(h)) la[i].textContent = 'Blog';
        else if (/videos/.test(h)) la[i].textContent = 'Educational Videos';
      }
      // Refined chevrons: replace the theme caret glyphs with one consistent SVG
      var CHEV = '<svg class="fll-dm2-chev" viewBox="0 0 12 12" width="11" height="11" aria-hidden="true" focusable="false"><path d="M2.75 4.5 6 7.75 9.25 4.5" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      var sums = nav.querySelectorAll('summary.header__menu-item');
      for (var si = 0; si < sums.length; si++) {
        var olds = sums[si].querySelectorAll('svg.icon-caret, .icon-caret, svg.fll-dm2-chev');
        for (var oi = 0; oi < olds.length; oi++) olds[oi].remove();
        sums[si].insertAdjacentHTML('beforeend', CHEV);
        sums[si].classList.add('fll-dm2-sum');
      }
      cLi.remove();
      [pLi, fLi, sLi, tLi, aLi, lLi].forEach(function (li) { nav.appendChild(li); });
      nav.classList.add('fll-dm2-nav');
    }
  }

  /* ---------- 4. Products mega-menu ---------- */
  var CATS = {
    nerve: { ink: '#457D26', wash: '#F3F8EE', line: '#CBE1B7', name: 'Nerve Health' },
    skin:  { ink: '#16668F', wash: '#EEF6FB', line: '#BBDCEF', name: 'Skin Care' },
    wound: { ink: '#196649', wash: '#EDF5F1', line: '#BCDBCB', name: 'Wound Care' },
    glp:   { ink: '#16456B', wash: '#EEF2F7', line: '#C3D3E1', name: 'GLP-1 Support' }
  };
  function catOf(s) {
    s = (s || '').toLowerCase();
    if (/nerve|neuropath|pain/.test(s)) return 'nerve';
    if (/derm|skin/.test(s)) return 'skin';
    if (/wound|surgery/.test(s)) return 'wound';
    if (/glp|peptalyn/.test(s)) return 'glp';
    return '';
  }
  function infoOf(s) {
    s = (s || '').toLowerCase();
    if (/pain|cream/.test(s)) return ['NerveReverse Pain Cream', 'Fast-acting topical relief', 'fll-pv2-pc.webp'];
    if (/nerve|neuropath/.test(s)) return ['NerveReverse Supplement', 'Supports nerve health', 'fll-pv2-nc.webp'];
    if (/derm/.test(s)) return ['Derm 42', 'For dry, cracked heels', 'fll-pv2-dm.webp'];
    if (/gel/.test(s)) return ['WoundWorx Gel', 'Nano-silver wound care', 'fll-pv2-wg.webp'];
    if (/wound|surgery/.test(s)) return ['WoundWorx Nutrition', 'Nutrition for surgery recovery', 'fll-pv2-ww.webp'];
    if (/peptalyn|glp/.test(s)) return ['Peptalyn', 'Built for GLP-1 users', 'peptalyn-bottle-cutout-v3.webp'];
    return null;
  }
  var BEST = 'nervereverse-neuropathy-support-formula';
  var panel = document.getElementById('fll-mega-v2');
  var inner = panel && panel.querySelector('.fll-mega__inner');
  if (inner) {
    var cols = inner.querySelectorAll('.fll-mega__col'), tiles = [], cats = [], seen = {};
    for (var c = 0; c < cols.length; c++) {
      var tt = cols[c].querySelector('.fll-mega__title'), all = cols[c].querySelector('.fll-mega__all');
      var gk = catOf(txt(tt) + ' ' + (tt && tt.getAttribute('href')));
      if (all && gk && !seen[gk]) { seen[gk] = 1; cats.push({ k: gk, href: all.getAttribute('href') }); }
      var cards = cols[c].querySelectorAll('.fll-mega__card');
      for (var j = 0; j < cards.length; j++) {
        var a = cards[j], href = a.getAttribute('href') || '', nm = txt(a.querySelector('.fll-mega__name'));
        var key = href + ' ' + nm, k = catOf(key) || gk || 'glp', inf = infoOf(key);
        var pre = (nm.match(/\((pre-?order[^)]*)\)/i) || [])[1] || (txt(tt).match(/\((pre-?order[^)]*)\)/i) || [])[1] || '';
        if (pre) pre = pre.replace(/pre-?order\s*-?\s*/i, 'Pre-order ');
        var rows = a.querySelectorAll('.fll-mega__price-row'), price = '';
        if (rows.length) { var ps = []; for (var r = 0; r < rows.length; r++) ps.push(txt(rows[r])); price = ps.join(' · '); }
        else price = txt(a.querySelector('.fll-mega__price'));
        var note = txt(a.querySelector('.fll-mega__case'));
        var img = a.querySelector('img');
        tiles.push({
          href: href, k: k, name: inf ? inf[0] : nm.replace(/\s*\(pre-?order[^)]*\)\s*/i, ''),
          benefit: inf ? inf[1] : '', thumb: inf ? inf[2].replace(/\.webp$/, '').replace('fll-pv2-', '') : '', img: inf && BASE ? BASE + inf[2] : (img ? img.getAttribute('src') : ''),
          price: noSub(price), note: noSub(note), pre: pre, best: !WS && href.indexOf('/products/' + BEST) !== -1
        });
      }
    }
    var foot = inner.querySelector('.fll-mega__foot');
    var allA = foot && foot.querySelector('.fll-mega__foot-links a');
    var allHref = allA ? allA.getAttribute('href') : '/collections/all';
    if (tiles.length) {
      var h = '<div class="fll-dm2-p">' +
        '<div class="fll-dm2-p__top"><span class="fll-dm2-p__eyebrow">Products</span>' +
        '<a class="fll-dm2-p__all" href="' + esc(allHref) + '">Shop all products <span aria-hidden="true">→</span></a></div>' +
        '<ul class="fll-dm2-p__grid" role="list">';
      tiles.forEach(function (t, i) {
        var C = CATS[t.k];
        h += '<li style="--i:' + i + '"><a class="fll-dm2-tile" href="' + esc(t.href) + '" style="--ink:' + C.ink + ';--wash:' + C.wash + ';--line:' + C.line + '">' +
          '<span class="fll-dm2-tile__img' + (t.thumb ? ' fll-dm2-tile__img--' + t.thumb : '') + '">' + (t.img ? '<img src="' + esc(t.img) + '" alt="" loading="lazy" width="96" height="96">' : '') + '</span>' +
          '<span class="fll-dm2-tile__body">' +
                    '<span class="fll-dm2-tile__name">' + esc(t.name) + '</span>' +
          (t.benefit ? '<span class="fll-dm2-tile__benefit">' + esc(t.benefit) + '</span>' : '') +
          '<span class="fll-dm2-tile__row">' + (t.price ? '<span class="fll-dm2-tile__price">' + esc(t.price) + '</span>' : '') +
          (t.best ? '<span class="fll-dm2-tag fll-dm2-tag--best">Best seller</span>' : '') +
          (t.pre ? '<span class="fll-dm2-tag">' + esc(t.pre) + '</span>' : '') + '</span>' +
          (t.note ? '<span class="fll-dm2-tile__note">' + esc(t.note) + '</span>' : '') +
          '</span></a></li>';
      });
      h += '</ul></div>';
      var wrap = document.createElement('div'); wrap.innerHTML = h;
      var old = inner.querySelector('.fll-mega__cols');
      if (old) old.replaceWith(wrap.firstChild); else inner.insertBefore(wrap.firstChild, foot);
      if (foot) {
        foot.classList.add('fll-dm2-foot');
        var fl = foot.querySelector('.fll-mega__foot-links'); if (fl) fl.style.display = 'none';
        if (WS) { var walk = foot.querySelectorAll('*'); for (var w = 0; w < walk.length; w++) if (!walk[w].children.length) walk[w].textContent = noSub(walk[w].textContent); }
      }
      panel.classList.add('fll-dm2-panel');
    }
  }
})();
